export default "<p>hulk-config-tailwindcss works!</p>\n"